import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import DataConnector from 'connect/DataConnector';
import {Status as AutomationFileStatusGraphQL} from 'graphql-client/__generated/graphqlGlobalTypes';
import {GRAY_LIGHTER} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';

interface RequiredSkipRowsWithErrorsBannerProps {
  automationOutputFile: AutomationOutputFileGraphQL;
}
interface ConnectedProps {
  outputFileStatus: AutomationFileStatusGraphQL | null;
}

class RequiredSkipRowsWithErrorsBannerConnector extends DataConnector<
  RequiredSkipRowsWithErrorsBannerProps,
  ConnectedProps
> {
  enhanceProps(): ConnectedProps {
    return {
      outputFileStatus: this.props.automationOutputFile.id
        ? this.reduxState().ui.automationFileStatus[this.props.automationOutputFile.id]
        : null,
    };
  }
}

const RequiredSkipRowsWithErrorsBanner: React.FunctionComponent<RequiredSkipRowsWithErrorsBannerProps> = (
  props: RequiredSkipRowsWithErrorsBannerProps & ConnectedProps
): JSX.Element | null => {
  if (props.outputFileStatus === AutomationFileStatusGraphQL.pending) {
    return (
      <div className={css(styles.banner)}>
        <span className={css(styles.bannerIcon)}>
          <BenchlingIcon icon="info-circle" className={css(styles.bannerIcon)} />
        </span>
        Because of the large size of this output file, processing will continue even if there are errors. You
        can view all successful and failed rows after processing is complete.
      </div>
    );
  }
  return null;
};

const styles = StyleSheet.create({
  bannerIcon: {
    marginRight: '10px',
  },
  banner: {
    backgroundColor: GRAY_LIGHTER,
    padding: '9px 12px',
    textAlign: 'left',
    flexDirection: 'row',
    display: 'flex',
    alignItems: 'flex-start',
    marginBottom: '10px',
  },
});

export default RequiredSkipRowsWithErrorsBannerConnector.connect(RequiredSkipRowsWithErrorsBanner);
